import React from 'react';

import Star from './Star';
export type StarRatingValidFilledValues =
  | 0
  | 0.5
  | 1
  | 1.5
  | 2
  | 2.5
  | 3
  | 3.5
  | 4
  | 4.5
  | 5;

export type RatingProps = {
  value: StarRatingValidFilledValues;
  isOnDark: boolean;
  className?: string;
  starHeight: number;
};

const calculateFilledStars = (value: number, index: number) => {
  if (index < Math.floor(value)) {
    return 1; // Fully filled star
  } else if (index === Math.floor(value) && value % 1 > 0) {
    return 0.5; // Half-filled star
  }
  return 0; // Unfilled star
};

const StarRating: React.FC<RatingProps> = ({
  value,
  isOnDark,
  className,
  starHeight,
}) => {
  if (
    typeof value !== 'number' ||
    ![0, 0.5, 1, 1.5, 2, 2.5, 3, 3.5, 4, 4.5, 5].includes(value)
  ) {
    console.error(
      'StarRating: Value must be a number and one of the following: 0, 0.5, 1, 1.5, 2, 2.5, 3, 3.5, 4, 4.5, 5'
    );
  }

  if (value > 5) {
    console.error('StarRating: Value cannot be greater than 5');
  }

  if (value < 0) {
    console.error('StarRating: Value cannot be less than 0');
  }

  return (
    <div data-testid='rating' className={className}>
      {Array.from({ length: 5 }).map((_, i) => (
        <Star
          key={i}
          filled={calculateFilledStars(value, i)}
          isOnDark={isOnDark}
          starWidth={starHeight}
        />
      ))}
    </div>
  );
};

export default StarRating;
